// Porta direta de reference/expo-frontend/lib/displayName.ts.
/**
 * Nome exibido de um usuário nos rankings/leaderboards.
 * Regra: se houver apelido preenchido, usa o apelido; caso contrário,
 * usa o primeiro nome + último sobrenome do nome completo.
 */
export function displayName(user: {
  name: string;
  nickname?: string | null;
}): string {
  const nick = user.nickname?.trim();
  if (nick) return nick;

  const parts = user.name.trim().split(/\s+/).filter(Boolean);
  if (parts.length <= 1) return user.name.trim();
  return `${parts[0]} ${parts[parts.length - 1]}`;
}
